import * as React from 'react';
import { Header, Message } from 'semantic-ui-react';

import { Resultados } from 'src/api';
import TablaDeCursos from './componentes/TablaDeCursos';
import { EstadoCurso } from './estadoCurso';

interface Props {
    nombreAlumno: React.ReactNode;
    asignaturasContratadas: Resultados<'cursosQueElAlumnoPuedeInscribir'>['asignaturasContratadas'];
    cursos: Resultados<'cursosQueElAlumnoPuedeInscribir'>['cursos'];
    infoMatricula: Resultados<'informacionMatricula'>['infoMatricula'];
    inscribir(idCurso: number): void;
    desinscribir(idCurso: number): void;
}

const Cursos: React.FunctionComponent<Props> = props => {
    const {
        nombreAlumno,
        asignaturasContratadas,
        cursos,
        infoMatricula,
        inscribir,
        desinscribir,
    } = props;

    const { detallePreu } = infoMatricula;

    return (
        <div>
            <Header as='h3'>{nombreAlumno}</Header>
            <Message>
                {detallePreu.modelo && (
                    <Message.Content>
                        <b>Plan: </b> {mapaDeNombresPlanes[infoMatricula.plan]}
                    </Message.Content>
                )}

                {detallePreu.modalidad && (
                    <Message.Content>
                        <b>Modalidad: </b> {mapaDeNombresModalidad[detallePreu.modalidad]}
                    </Message.Content>
                )}

                {detallePreu.jornada && (
                    <Message.Content>
                        <b>Jornada: </b> {mapaDeNombresJornada[detallePreu.jornada]}
                    </Message.Content>
                )}

                <Message.Content>
                    <b>Asignaturas contratadas:</b>{' '}
                    {asignaturasContratadas.map(a => mapaDeNombresDeAsignatura[a]).join(', ')}
                </Message.Content>

                <Message.Content>
                    <b>Electivo:</b> {mapaDeNombresElectivos[detallePreu.electivo]}
                </Message.Content>
            </Message>

            <TablaDeCursos
                cargando={cursos.length === 0}
                cursos={cursos}
                alClickearCurso={cursoProps => {
                    const { idCurso } = cursoProps;

                    if (cursoProps.estado === EstadoCurso.Inscribible) {
                        inscribir(idCurso);
                    } else if (cursoProps.estado === EstadoCurso.Inscrito) {
                        desinscribir(idCurso);
                    }
                }}
            />
        </div>
    );
};

const mapaDeNombresDeAsignatura: Record<string, string> = {
    matematica: 'Matemática',
    lenguaje: 'Lenguaje',
    historia: 'Historia',
    ciencias: 'Ciencias',
};

const mapaDeNombresModalidad: Record<string, string> = {
    presencial: 'Presencial',
    online: 'Online',
};

const mapaDeNombresJornada: Record<string, string> = {
    mañana: 'Mañana',
    tarde: 'Tarde',
    vespertino: 'Vespertino',
};

const mapaDeNombresPlanes = {
    'anual': 'Anual',
    'intensivo': 'Intensivo',
    'intensivo-vespertino': 'Intensivo vespertino',
};

const mapaDeNombresElectivos = {
    ninguno: 'Ninguno',
    biologia: 'Biología',
    fisica: 'Física',
    quimica: 'Química',
};

export default Cursos;



// WEBPACK FOOTER //
// ./src/modulos/Horarios/TomaDeHorarios/componentes/Inscribir/Cursos/index.tsx